__turbopack_context__.v({
  "answer": "website-readiness-demo-module__Ncto3a__answer",
  "assessment": "website-readiness-demo-module__Ncto3a__assessment",
  "body": "website-readiness-demo-module__Ncto3a__body",
  "caption": "website-readiness-demo-module__Ncto3a__caption",
  "checks": "website-readiness-demo-module__Ncto3a__checks",
  "draft": "website-readiness-demo-module__Ncto3a__draft",
  "gap": "website-readiness-demo-module__Ncto3a__gap",
  "gapLabel": "website-readiness-demo-module__Ncto3a__gapLabel",
  "header": "website-readiness-demo-module__Ncto3a__header",
  "identity": "website-readiness-demo-module__Ncto3a__identity",
  "interview": "website-readiness-demo-module__Ncto3a__interview",
  "interviewButton": "website-readiness-demo-module__Ncto3a__interviewButton",
  "panel": "website-readiness-demo-module__Ncto3a__panel",
  "prompt": "website-readiness-demo-module__Ncto3a__prompt",
  "results": "website-readiness-demo-module__Ncto3a__results",
  "saved": "website-readiness-demo-module__Ncto3a__saved",
  "scene": "website-readiness-demo-module__Ncto3a__scene",
  "status": "website-readiness-demo-module__Ncto3a__status",
  "steps": "website-readiness-demo-module__Ncto3a__steps",
  "track": "website-readiness-demo-module__Ncto3a__track",
});
